import Vue from 'vue';
export function Video() {
    const shoMoreContent = document.querySelectorAll('.video_section');
    (function () {
        if (!shoMoreContent || !shoMoreContent.length) {
            return false
        }
    })()
    let ids = [...shoMoreContent].map(el => el.id)
    if (ids && ids.length) {
        ids.forEach(el => {
            new Vue({
                el: `#${el}`,
                data() {
                    return {
                        play: false,
                    }
                },
                watch: {
                    play(v) {
                        if (v) {
                            setTimeout(() => {
                                const video = document.querySelector(`#${el} video.wp-video-shortcode`);
                                if (!video) {
                                    alert('Video not available, or something went wrong!')
                                }
                                video.play()
                            }, 400)
                        }
                    }
                },
            })
        })
    }
}
Video()